import { gql } from "@apollo/client";

export const AddMom = gql`
  mutation AddMom(
    $token: String!
    $customerID: ID!
    $user_details: SubscribedUser!
    $meetingDate: Time!
  ) {
    AddMom(
      token: $token
      customerID: $customerID
      user_details: $user_details
      meetingDate: $meetingDate
    )
  }
`;

export const UpdateMom = gql`
  mutation UpdateMom(
    $token: String!
    $momID: ID!
    $user_details: SubscribedUser!
    $meetingDate: Time!
  ) {
    UpdateMom(
      token: $token
      momID: $momID
      user_details: $user_details
      meetingDate: $meetingDate
    )
  }
`;

export const DeleteMom = gql`
  mutation DeleteMom(
    $token: String!
    $momID: ID!
    $user_details: SubscribedUser!
  ) {
    DeleteMom(token: $token, momID: $momID, user_details: $user_details)
  }
`;

export const AddPmuComments = gql`
  mutation AddPmuComments(
    $token: String!
    $user_details: SubscribedUser!
    $customerID: ID!
    $momID: ID!
    $projectID: ID!
    $input: [PmuCommentsInput!]!
  ) {
    AddPmuComments(
      token: $token
      user_details: $user_details
      customerID: $customerID
      momID: $momID
      projectID: $projectID
      input: $input
    ) {
      id
    }
  }
`;

export const UpdateVendorResponse = gql`
  mutation UpdateVendorResponse(
    $token: String!
    $user_details: SubscribedUser!
    $customerID: ID!
    $momID: ID!
    $projectID: ID!
    $input: [VendorResponseInput!]!
  ) {
    UpdateVendorResponse(
      token: $token
      user_details: $user_details
      customerID: $customerID
      momID: $momID
      projectID: $projectID
      input: $input
    )
  }
`;

export const UpdatePmuComments = gql`
  mutation UpdatePmuComments(
    $token: String!
    $user_details: SubscribedUser!
    $customerID: ID!
    $momDetailsID: ID!
    $input: PmuCommentsInput!
  ) {
    UpdatePmuComments(
      token: $token
      user_details: $user_details
      customerID: $customerID
      momDetailsID: $momDetailsID
      input: $input
    )
  }
`;

export const DeletePmuComments = gql`
  mutation DeletePmuComments(
    $token: String!
    $user_details: SubscribedUser!
    $customerID: ID!
    $momDetailsID: ID!
  ) {
    DeletePmuComments(
      token: $token
      user_details: $user_details
      customerID: $customerID
      momDetailsID: $momDetailsID
    )
  }
`;

export const AddMomAtt = gql`
  mutation AddMomAtt(
    $token: String!
    $customerID: ID!
    $user_details: SubscribedUser!
    $input: AttendanceData!
  ) {
    AddMomAtt(
      token: $token
      customerID: $customerID
      user_details: $user_details
      input: $input
    )
  }
`;

export const AddVendorNotes = gql`
  mutation AddVendorNotes(
    $token: String!
    $user_details: SubscribedUser!
    $customerID: ID!
    $momID: ID!
    $projectID: ID!
    $input: [VendorNotesInput!]!
  ) {
    AddVendorNotes(
      token: $token
      user_details: $user_details
      customerID: $customerID
      momID: $momID
      projectID: $projectID
      input: $input
    ) {
      id
    }
  }
`;

export const UpdateVendorNotes = gql`
  mutation UpdateVendorNotes(
    $token: String!
    $user_details: SubscribedUser!
    $customerID: ID!
    $momDetailsID: ID!
    $input: VendorNotesInput!
  ) {
    UpdateVendorNotes(
      token: $token
      user_details: $user_details
      customerID: $customerID
      momDetailsID: $momDetailsID
      input: $input
    )
  }
`;

export const DeleteVendorNotes = gql`
  mutation DeleteVendorNotes(
    $token: String!
    $user_details: SubscribedUser!
    $customerID: ID!
    $momDetailsID: ID!
  ) {
    DeleteVendorNotes(
      token: $token
      user_details: $user_details
      customerID: $customerID
      momDetailsID: $momDetailsID
    )
  }
`;

export const UpdatePmuResponse = gql`
  mutation UpdatePmuResponse(
    $token: String!
    $user_details: SubscribedUser!
    $customerID: ID!
    $momDetailsID: ID!
    $input: PmuResponseInput!
  ) {
    UpdatePmuResponse(
      token: $token
      user_details: $user_details
      customerID: $customerID
      momDetailsID: $momDetailsID
      input: $input
    )
  }
`;

export const UpdateViewedStatus = gql`
  mutation UpdateViewedStatus(
    $token: String!
    $user_details: SubscribedUser!
    $customerID: ID!
    $momID: ID!
    $projectID: ID!
    $viewed: Boolean!
  ) {
    UpdateViewedStatus(
      token: $token
      user_details: $user_details
      customerID: $customerID
      momID: $momID
      projectID: $projectID
      viewed: $viewed
    )
  }
`;
